import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const fromDtoToStripeResponse = (dto) => ({
  stripeLink: dto?.stripe_link,
  isAccountComplete: dto?.is_account_complete,
});

export const beSalonStripeAccountWrite = actionEndpointBe('beSalonStripeAccountWrite', H.post, 'payments/stripe/setup/salon/account/:salonId/', (options) => ({
  ...options,
  inert: true,
  isMissingParams: false,
  umsg: UMSG_TYPE.global,
  fromDto: fromDtoToStripeResponse,
}));

export const beSalonStripeAccountRead = actionEndpointBe('beSalonStripeAccountRead', H.get, 'payments/stripe/setup/salon/account/:salonId/', (options) => ({
  ...options,
  inert: true,
  fromDto: fromDtoToStripeResponse,
}));
